import React, { useContext, useEffect, useRef, useState } from "react";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, MenuItem, Select, Spinner, UseDisclosureProps, useDisclosure } from "@chakra-ui/react";
import { faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ContentContext from "../../../common/context/ContentContext";
import { useDispatch, useSelector } from "react-redux";
import { contentActions, contentState } from "../../../store/slices/content";
import { subjectActions, subjectState } from "../../../store/slices/subject";
import { userState } from "../../../store/slices/user";
import useDynamicRequest from "../../../common/hooks/useDynamicRequest";
import { useNavigate } from "react-router-dom";
import { Content } from "../../../common/types";

const MoveDialog = ({ isOpen, onClose, onMove }: { isOpen: boolean, onClose: () => void, onMove: (id: string) => void }) => {
    const cancelRef: React.RefObject<any> = useRef();
    const dispatch = useDispatch();
    const { isLoadingSubjects, subjects, hasErrorLoadingSubjects } =
        useSelector(subjectState);
    const { user } = useSelector(userState);
    const [selected, setSelected] = useState("");

    useEffect(() => {
        dispatch(subjectActions.loadSubjects(user!._id));
    }, []);

    return <AlertDialog
        isOpen={isOpen!}
        leastDestructiveRef={cancelRef}
        onClose={onClose!}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    Mover Contenido
                </AlertDialogHeader>

                <AlertDialogBody>
                    Selecciona el nuevo Tema
                    {isLoadingSubjects && <Spinner />}
                    {!isLoadingSubjects && !hasErrorLoadingSubjects &&
                        <Select onChange={(e) => { setSelected(e.target.value) }}>
                            {subjects.map(s => <option value={s._id}>{s.name}</option>)}
                        </Select>
                    }
                </AlertDialogBody>

                <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                        Cancelar
                    </Button>
                    <Button colorScheme='red' onClick={() => { onMove(selected) }} ml={3}>
                        Mover
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>
}

const MoveButton = ({ mode }: { mode?: "button" | "menu-item" }) => {
    const content = useContext(ContentContext);
    const dispatch = useDispatch();
    const [_, callUpdate] = useDynamicRequest<Content>();
    const navigate = useNavigate();
    const { isSaving } = useSelector(contentState);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const onMove = (subjectId: string) => {
        if (content) {
            callUpdate("PATCH", `/content/${content!._id}`, { subject: subjectId }, {
                onSuccess: (uContent) => {
                    onClose();
                    dispatch(contentActions.updateContentCompleted(uContent))
                    navigate(`/subjects/${subjectId}/contents`, {
                        replace: true,
                    });
                },
            });
        }
    };

    return (
        <>
            {mode === "menu-item" ?
                <MenuItem onClick={() => { onOpen(); }} icon={isSaving ? <Spinner /> : <FontAwesomeIcon icon={faRightFromBracket} />}>
                    Mover Contenido a otro Tema
                </MenuItem> :
                <Button
                    colorScheme="telegram"
                    variant="outline"
                    leftIcon={<FontAwesomeIcon icon={faRightFromBracket} />}
                    onClick={() => { onOpen(); }}
                    isLoading={isSaving}
                >
                    Mover Contenido a otro Tema
                </Button>
            }
            <MoveDialog isOpen={isOpen} onClose={onClose} onMove={onMove} />
        </>
    );
};

export default MoveButton;
